export default __webpack_public_path__ + "static/illustration-content-desc.url-2344c3b697f7ee84d1212686c22b8efb.svg";